import { phoneInputHandler } from '../../../../templates/main/phoneInputHandler';
import { waveEffect } from '../../../../templates/main/waveEffect';

export const Form = {
    props: {
        phone: {
            type: String,
            default: '',
        },
        phoneCode: {
            type: String,
            default: '',
        },
        workTime: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        formData: {
            form_text_4: '',
            form_text_5: '',
        },
        spinner: false,
        submited: false,
        countdown: 30,
        intervalId: null,
        phoneError: false,
    }),
    methods: {
        send: function (event) {
            const protectionPreventedSubmit = event.defaultPrevented;
            event.preventDefault();

            const phoneNumber = this.formData.form_text_5.replace(/\D/g, '');
            this.phoneError = phoneNumber.length < 9;
            if (this.phoneError || protectionPreventedSubmit) {
                return;
            }

            this.spinner = true;
            BX.ajax.runComponentAction('vv:forms', 'save', {
                mode: 'class',
                data: {data: {fields: this.formData, form_id: 'callback'}},
            }).then((response) => {
                this.spinner = false;
                if (response.data.status === 'success') {
                    const now = new Date().getTime();
                    localStorage.setItem('lastFormCallbackBeforeFooterSubmitTime', now);
                    this.submited = true;
                    this.startCountdown();
                } else {
                    console.error('Ошибка при отправке данных', response.data.message);
                }
            }).catch((error) => {
                this.spinner = false;
                console.error('Ошибка при отправке данных', error);
            });
        },
        handlePhoneInput: function () {
            const phoneNumber = this.formData.form_text_5.replace(/\D/g, '');
            if (phoneNumber.length >= 9) {
                this.phoneError = false;
            }
        },
        handlePhoneBlur: function () {
            const phoneNumber = this.formData.form_text_5.replace(/\D/g, '');
            if (phoneNumber.length > 0 && phoneNumber.length < 9) {
                this.phoneError = true;
            }
        },
        startCountdown: function () {
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            this.intervalId = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.clearForm();
                }
            }, 1000);
        },
        clearForm: function () {
            localStorage.removeItem('lastFormCallbackBeforeFooterSubmitTime');
            clearInterval(this.intervalId);
            this.intervalId = null;
            this.formData = {
                form_text_4: '',
                form_text_5: '',
            };
            this.submited = false;
            this.phoneError = false;
            this.countdown = 30;
        },
    },
    mounted () {
        phoneInputHandler();
        waveEffect();

        const lastSubmitTime = localStorage.getItem('lastFormCallbackBeforeFooterSubmitTime');
        if (lastSubmitTime) {
            const now = new Date().getTime();
            const diff = now - lastSubmitTime;
            const remainingTime = 30 - Math.floor(diff / 1000);
            if (remainingTime > 0) {
                this.countdown = remainingTime;
                this.submited = true;
                this.startCountdown();
            } else {
                localStorage.removeItem('lastFormCallbackBeforeFooterSubmitTime');
            }
        }
    },
    beforeUnmount () {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
    template: `<div class="callback-before-footer">
                    <div class="callback-before-footer__container">
                        <div class="callback-before-footer__card">
                            <div class="callback-before-footer__info">
                                <h2 class="callback-before-footer__title" id="callback-before-footer-title">Остались вопросы?</h2>
                                <p class="callback-before-footer__lead">Оставьте номер — мы перезвоним и ответим на вопросы.</p>

                                <ol class="callback-before-footer__steps" aria-label="Как проходит обращение">
                                    <li class="callback-before-footer__step">
                                        <img class="callback-before-footer__step-icon" src="/local/js/vv/form_callback_before_footer/assets/step-contacts.svg" width="64" height="64" alt="">
                                        <span class="callback-before-footer__step-text">Оставляете<br>контакты</span>
                                    </li>
                                    <li class="callback-before-footer__step">
                                        <img class="callback-before-footer__step-icon" src="/local/js/vv/form_callback_before_footer/assets/step-discussion.svg" width="64" height="64" alt="">
                                        <span class="callback-before-footer__step-text">Обсуждаем<br>задачу</span>
                                    </li>
                                    <li class="callback-before-footer__step">
                                        <img class="callback-before-footer__step-icon" src="/local/js/vv/form_callback_before_footer/assets/step-solution.svg" width="64" height="64" alt="">
                                        <span class="callback-before-footer__step-text">Подбираем<br>решение</span>
                                    </li>
                                </ol>

                                <div v-if="phone" class="callback-before-footer__phone">
                                    <span class="callback-before-footer__phone-label">Можно позвонить нам</span>
                                    <a v-if="phoneCode" class="callback-before-footer__phone-number" :href="'tel:' + phoneCode">{{ phone }}</a>
                                    <span v-else class="callback-before-footer__phone-number">{{ phone }}</span>
                                    <span v-if="workTime" class="callback-before-footer__phone-hours">{{ workTime }}</span>
                                </div>
                            </div>

                            <div class="callback-before-footer__form-shell">
                                <form action="" class="form callback-before-footer__form" @submit="send" novalidate aria-labelledby="callback-before-footer-title">
                                    <div class="callback-before-footer__fields">
                                        <div class="callback-before-footer__field-group">
                                            <label class="callback-before-footer__visually-hidden" for="callback-before-footer-name">Как к Вам обращаться?</label>
                                            <input id="callback-before-footer-name" type="text" :class="['form__field', {'form__field--disabled': (spinner || submited)}]" v-model="formData.form_text_4" placeholder="Имя" autocomplete="name" :disabled="spinner || submited">
                                        </div>
                                        <div class="callback-before-footer__field-group">
                                            <label class="callback-before-footer__visually-hidden" for="callback-before-footer-phone">Ваш номер телефона</label>
                                            <input id="callback-before-footer-phone" type="tel" :class="['form__field', 'js-phone', {'form__field--disabled': (spinner || submited)}, {'form__field--error': phoneError}]" v-model="formData.form_text_5" @input="handlePhoneInput" @blur="handlePhoneBlur" placeholder="+7 (___) ___-__-__" autocomplete="tel" inputmode="tel" aria-required="true" :aria-invalid="phoneError ? 'true' : 'false'" aria-describedby="callback-before-footer-phone-error" :disabled="spinner || submited">
                                            <div id="callback-before-footer-phone-error" class="form__message-error" aria-live="polite">{{ phoneError ? 'Укажите номер телефона полностью.' : '' }}</div>
                                        </div>
                                    </div>

                                    <div class="callback-before-footer__captcha-slot" data-form-protection-captcha-slot></div>
                                    <div class="form__conf"></div>

                                    <div class="callback-before-footer__action" aria-live="polite">
                                        <div v-if="submited" class="form__submited">
                                            <span>Отправлено</span>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 7.2 5.4 10 11.5 3.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                        </div>
                                        <div class="form__sending" v-if="spinner" role="status" aria-label="Заявка отправляется">
                                            <div class="form__spinner" aria-hidden="true"><div></div><div></div><div></div><div></div></div>
                                        </div>
                                        <button v-if="!spinner && !submited" type="submit" class="form__submit btn">Перезвоните мне</button>
                                    </div>
                                    <div v-if="submited" class="form__disabled-time">Форму можно повторно отправить через {{ countdown }} сек.</div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>`,
};
